module.exports = __webpack_public_path__ + "media/assets/community_index/close-icon-c9d75102fc5ea5b91342f81dd6332a25dd746191a900b83fc79e5dad3346cfb9.png";